import { ThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import * as Sentry from '@sentry/react'
import { ConnectedRouter } from 'connected-react-router'
import LogRocket from 'logrocket'
import moment from 'moment'
import 'moment/locale/en-gb'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import 'react-image-lightbox/style.css'
import 'pure-react-carousel/dist/react-carousel.es.css'

import App from './modules/app/components/App'
import theme from './modules/ui/theme'
import createStore, { history } from './createStore'
import config from './config'

moment.locale('en-gb')
const store = createStore()

if (config.sentry.dsn) {
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    normalizeDepth: 10,
    // react-virtuoso fires these out for some reason
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [new Sentry.Replay()],
  })
}

if (config.stage === 'prod') {
  LogRocket.init('xfdwdb/tried-and-supplied')
  ReactGA.initialize('UA-130589189-1')
  history.listen(location => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  })
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <CssBaseline />
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </Provider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
